/**
 * Column-menu icon strings for the Product Number three-dot menu. The glyphs live
 * in the shared Bombiix icon set (SortAscendingIcon, PinColumnIcon); AG Grid's
 * `MenuItemDef.icon` accepts an HTML string, so each component is rendered to
 * static SVG markup once at module load. Sort Descending reuses the ascending
 * arrow flipped vertically.
 */

import { createElement } from 'react';
import type { CSSProperties, FC } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { PinColumnIcon, SortAscendingIcon } from '../../../../bombiix-icon';
import type { BombiixIconProps } from '../../../../bombiix-icon/types';

/** Render a Bombiix icon component to a 16px SVG markup string for AG Grid menus. */
const toMenuIcon = (Icon: FC<BombiixIconProps>, style?: CSSProperties): string =>
  renderToStaticMarkup(createElement(Icon, { size: 16, style }));

export const COLUMN_MENU_ICON = {
  sortAscending: toMenuIcon(SortAscendingIcon),
  sortDescending: toMenuIcon(SortAscendingIcon, { transform: 'scaleY(-1)' }),
  pin: toMenuIcon(PinColumnIcon),
} as const;
